import React, { useEffect, useState, useMemo, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setPage } from "../store/slices/pageSlice";
import { setPaymentType } from "../store/slices/paymentSlice";
import { clearSelectedPromo } from "../store/slices/selectedPromoSlice";
import getIcon from "../utils/Icon";
import walletOutlinedIcon from "../assets/icon/wallet_outlined.png";
import userApi from "../api/userApi";

export default function BalanceActionsBar() {
    const dispatch = useDispatch();
    const currentPageId = useSelector((s) => s.page.currentPageId);
    const [hasWallet, setHasWallet] = useState(false);

    useEffect(() => {
        userApi
            .getMe()
            .then((user) => setHasWallet(!!user?.walletAddress))
            .catch(() => setHasWallet(false));
    }, []);

    const handlePaymentTab = useCallback(
        (type) => {
            dispatch(clearSelectedPromo());
            dispatch(setPaymentType(type));
            if (currentPageId !== 7) {
                dispatch(setPage({ id: 7, name: "payment" }));
            }
        },
        [dispatch, currentPageId]
    );

    const goWallet = useCallback(() => {
        if (currentPageId !== 9) {
            dispatch(setPage({ id: 9, name: "wallet" }));
        }
    }, [dispatch, currentPageId]);

    const actions = useMemo(
        () => [
            { icon: "dep", label: "Deposit", onPress: () => handlePaymentTab("deposit") },
            { icon: "withdraw", label: "Withdraw", onPress: () => handlePaymentTab("withdraw") },
            { icon: "history", label: "History", onPress: () => handlePaymentTab("history") },
            { icon: null, label: "Wallet", onPress: goWallet, isWallet: true },
        ],
        [handlePaymentTab, goWallet]
    );

    return (
        <div className="flex-shrink-0 w-full px-4 pb-6 pt-3">
            <div className="w-full grid grid-cols-4 gap-2">
                {actions.map(({ icon, label, onPress, isWallet }) => (
                    <button
                        key={label}
                        type="button"
                        onClick={onPress}
                        className="relative flex flex-col items-center gap-1.5 py-3 rounded-2xl bg-[#F7C520] active:opacity-75 transition-opacity"
                    >
                        {isWallet ? (
                            <img src={walletOutlinedIcon} alt="wallet" width={22} height={22} className="object-contain" />
                        ) : (
                            <img width={22} height={22} src={getIcon(icon)} alt={label} />
                        )}
                        <span className="text-[11px] font-semibold text-black leading-none">{label}</span>
                        {isWallet && hasWallet && (
                            <span className="absolute top-2 right-2 w-2 h-2 rounded-full bg-emerald-400 border border-[#F7C520]" />
                        )}
                    </button>
                ))}
            </div>
        </div>
    );
}
